// extracted by mini-css-extract-plugin
export default {"doc":"ChatFileResource_doc__upszw","image":"ChatFileResource_image__hwWlX"};